<template>
  <v-container color="white" ma-0 pa-0 fluid>
    <v-navigation-drawer v-model="openDrawer" mini-variant-width="50" app :mini-variant.sync="mini" fixed clipped
      clipped-left hide-overlay disable-resize-watcher>
      <v-layout column ma-0 pa-0>
        <v-layout row ma-0 pa-0 style="width: 100%">
          <slot name="left_draw_top" :mini="mini">
          </slot>
          <v-spacer></v-spacer>
          <v-icon color="success" @click.stop="mini = !mini">
            {{mini?"mdi-arrow-collapse-right":"mdi-arrow-collapse-left"}}</v-icon>
        </v-layout>
        <v-container ma-0 pa-0 v-show="!mini">
          <slot name="left-drawer">
          </slot>
        </v-container>
      </v-layout>
    </v-navigation-drawer>
    <v-card-title ref="title" class="white" style="margin: 0px;padding: 0px;">
      <slot name="toolbar"></slot>
    </v-card-title>
    <slot></slot>
  </v-container>
</template>

<style>
  .v-navigation-drawer {
    overflow-x: auto;
  }



  .el-tree {
    display: inline-block !important;
  }
</style>

<script>
  import GhPage from "./ghPage.ts";
  export default GhPage;
</script>